<template>
  <div id="app">
    <HeaderComponent v-if="!$route.meta.hideLayout" />
    <router-view />
    <FooterComponent v-if="!$route.meta.hideLayout" />
    <BackToTop />
  </div>
</template>

<script>
import HeaderComponent from './components/Header/index.vue';
import FooterComponent from './components/Footer/index.vue';
import BackToTop from './components/BackToTop/index.vue';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: 'FreightSans Pro', sans-serif;
  background-color: #fff;
}
</style>
